import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import { useTranslation } from 'react-i18next';
import { getNumberOfPages, getPageFromQuery, locationWithPageNumber } from 'utils/pagination';
import { useFetchMyTodoContent, PROFILE_ITEMS_PER_PAGE } from 'actions/content';
import Box from 'components/Box';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import Pagination from 'components/Pagination';
import Stack from 'components/Stack';
import HeadingWithFilters from 'components/HeadingWithFilters';
import ContentTypeFilter from '../ContentTypeFilter';
import ItemsGrid from '../ItemsGrid';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Todo() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var type = queryParams.type;
  var page = getPageFromQuery({
    query: queryParams
  });
  var _useFetchMyTodoConten = useFetchMyTodoContent({
      type: type,
      page: page
    }),
    items = _useFetchMyTodoConten.items,
    isLoading = _useFetchMyTodoConten.isLoading,
    isError = _useFetchMyTodoConten.isError,
    total = _useFetchMyTodoConten.total;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: PROFILE_ITEMS_PER_PAGE
  });
  var outstanding = items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return !!item.goal;
  });
  var achieved = items === null || items === void 0 ? void 0 : items.filter(function (item) {
    return !item.goal;
  });
  var showOutstanding = pageCount > 1 ? outstanding && (outstanding === null || outstanding === void 0 ? void 0 : outstanding.length) > 0 : true;
  var showAchieved = pageCount > 1 ? achieved && (achieved === null || achieved === void 0 ? void 0 : achieved.length) > 0 : true;
  var hasFilters = type && type !== 'all';
  var outstandingEmptyContent = hasFilters ? t('error_no_filter_results') : t('error_no_outstanding_todos');
  var achievedEmptyContent = hasFilters ? t('error_no_filter_results') : t('error_no_achieved_todos');
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(HeadingWithFilters, {
      heading: /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: t('to_do_title')
      }),
      children: /*#__PURE__*/_jsx(ContentTypeFilter, {})
    }), /*#__PURE__*/_jsxs(Stack, {
      spacing: "l",
      children: [showOutstanding && /*#__PURE__*/_jsxs("section", {
        "aria-labelledby": "outstanding-todos",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          size: "small",
          mb: "s",
          id: "outstanding-todos",
          children: t('state_outstanding')
        }), /*#__PURE__*/_jsx(ItemsGrid, {
          items: outstanding,
          isError: isError,
          isLoading: isLoading,
          emptyContent: outstandingEmptyContent
        })]
      }), showAchieved && /*#__PURE__*/_jsxs("section", {
        "aria-labelledby": "achieved-todos",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          size: "small",
          mb: "s",
          id: "achieved-todos",
          children: t('state_achieved')
        }), /*#__PURE__*/_jsx(ItemsGrid, {
          items: achieved,
          isError: isError,
          isLoading: isLoading,
          emptyContent: achievedEmptyContent
        })]
      })]
    }), pageCount > 1 && /*#__PURE__*/_jsx(Box, {
      mt: "m",
      children: /*#__PURE__*/_jsx(Pagination, {
        pageCount: pageCount,
        currentPage: page,
        getPageLink: function getPageLink(pageNumber) {
          return locationWithPageNumber({
            location: location,
            page: pageNumber
          });
        }
      })
    })]
  });
}
export default Todo;